import React from 'react';
import classnames from 'classnames';

var styles = {"divider":"dH7SqeSo70A-","large":"_07xjw8ykfvg-","larger":"TGD22T-KP78-","largest":"UUndaiRIryU-","horizontal":"HzWBc8FoucI-","vertical":"vu46ZKcGBWM-"};

function Divider({ size = "base", direction = "horizontal", }) {
    const className = classnames(styles.divider, {
        [styles.large]: size === "large",
        [styles.larger]: size === "larger",
        [styles.largest]: size === "largest",
        [styles.horizontal]: direction == "horizontal",
        [styles.vertical]: direction == "vertical",
    });
    return React.createElement("div", { className: className, role: "none presentation" });
}

export { Divider as D };
